import React from 'react';
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import ReactDOM from 'react-dom';
import './index.css';
import Header from './components/Header';
import CitizenData from './components/CitizenData'
import CPData from "./components/CPData";

ReactDOM.render(
  <React.StrictMode>
    <Header />
    <Router>
      <nav>
            <Link to="/Citizen">Citizen </Link>
            <Link to="/CP">Civil Protection</Link>
      </nav>
      <Switch>
        <Route path ="/CP">
          <CPData />
        </Route>
        <Route path="/Citizen">
          <CitizenData />
        </Route>
      </Switch>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);
